import { VideoReferenceTemplateLibrary } from "@/components/admin/video-reference-template-library";

/**
 * Regular-UI page for managing the Video Reference Ads template library,
 * mirroring how Static Ad Units get their own brand page. Access is gated
 * by the same VideoReferenceAdsGuard (master + brand availability) as the
 * Video Reference Ads page itself.
 */
export default function VideoReferenceTemplateLibraryPage() {
  return (
    <div className="container mx-auto max-w-6xl px-4 py-6">
      <VideoReferenceTemplateLibrary />
    </div>
  );
}
